<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>BLUE YODEL 2</span></p>
<p class="chap-subtitle1"><span>KEN</span></p>
<p class="indent"><i>I know this guy, says he has Flower Guilt</i>.</p>
<p class="indent">“<i>What?” I say</i>.</p>
<p class="indent"><i>He says, “Let’s face it: Men don’t like flowers</i>.”</p>
<p class="indent"><i>I say I like flowers</i>.</p>
<p class="indent">“<i>Okay,” he says. “You</i> like <i>flowers. But you don’t</i> love <i>flowers</i>.”</p>
<p class="indent">“<i>I don’t know,” I say</i>.</p>
<p class="indent">“<i>But you aren’t</i> moved <i>by flowers,” he says</i>.</p>
<p class="indent">“<i>I really like planting zinnias,” I say</i>.</p>
<p class="indent">“<i>Ah!” he says. “Sure. Delving in the ground. Improving your property. But you don’t like</i> getting <i>flowers</i>.”</p>
<p class="indent">“<i>I guess I don’t. Because it would mean I was in the hospital</i>.”</p>
<p class="indent">“<i>Exactly,” he says. “But women like getting flowers</i>.”</p>
<p class="indent"><i>I say that’s true</i>.</p>
<p class="indent">“<i>Women</i> love <i>getting flowers. Women are</i> moved <i>when they get flowers. All women. Every woman. Sending flowers to a woman is like</i> … heroin <i>to them</i>.”</p>
<p class="indent">“<i>Well…,” I say</i>.</p>
<p class="indent">“<i>Okay. But you see my point. My point is, all a man has to do is call a florist</i> — <i>‘Dozen roses, MasterCard number so-and-so, address such-and-such’</i> — <i>and he has done something that a woman will perceive as sweet</i>.”</p>
<p class="indent">“<i>So what’s wrong with that?</i>”</p>
<p class="indent">“<i>To a woman, having flowers sent to her is thoughtful. To a man, sending flowers is a way of being thoughtful without putting any thought into it. It’s like foreign aid</i>.”</p>
<p class="indent"><i>I told him I wasn’t sure I saw the connection there</i>.</p>
<p class="indent">“<i>Okay, forget that,” he says. “My point is, when you can melt a woman by doing something that doesn’t involve any intrinsic emotion on your part, detachment sets in. Dissociation. Guilt. I send my wife flowers every couple of weeks. A computer could do it. It makes her happy</i>. It makes her happy.” <i>He has this pained look. “I’m</i> glad <i>she’s happy. But…</i>”</p>
<p class="indent">“<i>Okay,” I say. “So why don’t you send Shana</i>”— <i>that’s his wife</i> — “<i>why don’t you send Shana something thoughtful that</i> does <i>require thought?</i>”</p>
<p class="indent">“<i>Because that’s how I always get in trouble</i>.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?a9ee0866